import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

import UsersExportForm from '../components/UsersExportForm';
import AddUserForm from '../components/AddUserForm';
import UserTableItem from '../components/UserTableItem';
import Preloader from '../components/Preloader';

import { deleteUser, loadUsers, addUser, clearUserErrors } from '../actions/userActions';
import { exportData, clearExportLink, saveSettingValue, clearMessages, saveCulture, deleteCulture } from '../actions/settingsActions';
import { MANAGE_TASKS } from '../constants/routes';
import CustomScrollbars from '../components/CustomScrollbars';

class AddUserPage extends Component {
	componentWillMount () {
		this.props.loadUsers();
	}

	render () {
		const { users, addUser: add, deleteUser: del, loading, initData, serverError, exportLink, alertData, messageShowed, filteredCultures, clearUserErrors: clearErrors } = this.props;

		if (loading) {
			return <Preloader />
		}

		return <div className="container">
			<h4>Перейти к <Link to={MANAGE_TASKS}>редактированию задач</Link></h4>

			<AddUserForm onSubmit={add} selectData={initData} serverError={serverError} clearErrors={clearErrors} />
			
			<h3 className="text-center">Пользователи</h3>
			{
				users.length && !loading ?
					<CustomScrollbars autoHeight autoHeightMin={0} autoHeightMax={800} className="mr-bottom-40">
						<table className="table table-bordered users-list-settings">
							<thead>
								<tr>
									<th>Номер</th>
									<th>Логин</th>
									<th>Имя</th>
									<th>Последн. акт.</th>
									<th>Полномочия</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								{
									users.map((user, key) =>
										<UserTableItem key={key} user={user} onDeleteClick={del} role={initData.roles.filter((r) => +r.value === +user.role)} />)
								}
							</tbody>
						</table>
					</CustomScrollbars> : 'Не найдено ни одного юзера'
			}

			<UsersExportForm
				selectData={initData}
				clearExportLink={this.props.clearExportLink}
				onExportClick={this.props.exportData}
				saveSettingValue={this.props.saveSettingValue}
				exportLink={exportLink}
				alertData={alertData}
				messageShowed={messageShowed}
				clearMessages={this.props.clearMessages}
				filteredCultures={filteredCultures}
				saveCulture={this.props.saveCulture}
				deleteCulture={this.props.deleteCulture}
			/>
		</div>
	}
}

AddUserPage.propTypes = {
	users: PropTypes.array,
	deleteUser: PropTypes.func.isRequired,
	loadUsers: PropTypes.func.isRequired,
	addUser: PropTypes.func.isRequired,
	loading: PropTypes.bool,
	initData: PropTypes.object,
	serverError: PropTypes.string,
	exportData: PropTypes.func.isRequired,
	clearExportLink: PropTypes.func.isRequired,
	exportLink: PropTypes.string,
	saveSettingValue: PropTypes.func.isRequired,
	alertData: PropTypes.object,
	messageShowed: PropTypes.bool,
	clearMessages: PropTypes.func.isRequired,
	filteredCultures: PropTypes.array,
	clearUserErrors: PropTypes.func.isRequired,
	deleteCulture: PropTypes.func.isRequired,
	saveCulture: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
	users: state.users.list,
	loading: state.users.loading || !state.webInterface.initData,
	initData: state.webInterface.initData,
	serverError: state.users.error,
	exportLink: state.settings.exportLink,
	messageShowed: state.settings.messageShowed,
	alertData: {
		form: state.settings.form,
		error: state.settings.error,
		text: 'Операция успешно произведена'
	},
	filteredCultures: state.settings.cultures
});

const mapDispatchToProps = dispatch => bindActionCreators({
	deleteUser, loadUsers, addUser, exportData, clearExportLink, saveSettingValue: saveSettingValue, clearMessages, clearUserErrors, deleteCulture, saveCulture
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddUserPage);



// WEBPACK FOOTER //
// ./containers/SettingsPage.js